import React, { Component } from "react"
import { Menu, Sidebar, Icon, Accordion } from "semantic-ui-react"
import "./styles/styles.css"
import { GiFlowerPot } from "react-icons/gi"
import { Link } from "react-router-dom"
import ArrayMovil from "../../../Arrays/ArraysMovil"
import CurrencySelect from "../../../CurrencySelect/CurrencySelect"
import SearchBar from "../../../../Search/Search"

class IconSideBar extends Component {
  state = { visible: false, activeIndex: 0 }
  handleClickAccordion = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index

    this.setState({ activeIndex: newIndex })
  }

  handleHideClick = () => this.setState({ visible: false })
  handleShowClick = () => this.setState({ visible: true })
  handleSidebarHide = () => this.setState({ visible: false })

  render() {
    const { visible, activeIndex } = this.state
    return (
      <div>
        <i
          disabled={visible}
          onClick={this.handleShowClick}
          className='big bars icon'
        />

        <Sidebar
          as={Menu}
          animation='overlay'
          icon='labeled'
          inverted
          onHide={this.handleSidebarHide}
          vertical
          visible={visible}
          className='side'
          style={{ width: "70%" }}
        >
          <Menu.Item
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <SearchBar
              products={this.props.products}
              handleHideClick={this.handleHideClick}
              clave='movil'
              setVisibleSearch={this.props.setVisibleSearch}
            />
          </Menu.Item>

          <Menu.Item
            as={Link}
            to='/'
            disabled={!visible}
            onClick={this.handleHideClick}
          >
            <Icon name='home' />
            Inicio
          </Menu.Item>

          <Menu.Item>
            <Accordion>
              <Accordion.Title
                active={activeIndex === 1}
                index={1}
                onClick={this.handleClickAccordion}
              >
                <Menu.Item>
                  <Icon>
                    <GiFlowerPot size={30}></GiFlowerPot>
                  </Icon>
                  Arreglos
                </Menu.Item>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 1}>
                <ArrayMovil
                  index={this.props.index}
                  setIndex={this.props.setIndex}
                  categories={this.props.categories}
                  handleHideClick={this.handleHideClick}
                />
              </Accordion.Content>
            </Accordion>
          </Menu.Item>

          <Menu.Item
            as={Link}
            to='/gallery'
            disabled={!visible}
            onClick={this.handleHideClick}
          >
            <Icon name='images' />
            Nuestros Clientes
          </Menu.Item>
          <Menu.Item
            as={Link}
            to='/blog'
            disabled={!visible}
            onClick={this.handleHideClick}
            className='item1'
          >
            <Icon name='newspaper' />
            Blog
          </Menu.Item>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "center",
              height: "30%",
              width: "100%",
            }}
          >
            <CurrencySelect index={true} />
          </div>
        </Sidebar>
      </div>
    )
  }
}

export default IconSideBar
